import router from "./router";
import { setToken,removeToken } from "@/libs/cookie-storage";
import { AppType } from '@/constants/appType'
import wx from 'weixin-js-sdk'
import { buildFullHashRedirectUrl } from '@/utils/redirect'


router.beforeEach((to, from, next) => {
  if (to.query.passport) {
    setToken(to.query.passport)
  }
  if (to.query.source === 'wxmini' && !to.query.passport){
    removeToken()
  }
  if (to.name === 'AuthLogin') {
    if (AppType.isInWeChat()) {  // 微信环境
      // 同步判断是否在微信小程序
      const ua = window.navigator.userAgent.toLowerCase()
      if (ua.indexOf('micromessenger') > -1 && window.__wxjs_environment === 'miniprogram') {
        // 微信小程序环境
        const url = '/pages/common/login?redirect=' + encodeURIComponent(buildFullHashRedirectUrl())
        wx.miniProgram.navigateTo({ url })
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})
